import { axiosRequest } from './../../service/axios';

export default (params) => {
  const url = 'action-log/list';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    params,
    options,
  };
  return axiosRequest(axiosData);
};
